<div class="wrapper-mini text-center auth-form">
    <h1 class="header">Toaster-Tester</h1>

    <div class="form-block text-left">
        <label for="email">Enter a word...</label>
        <input type="text" name="email" data-testid="input-toast-test-word" [(ngModel)]="dummy_word" (keyup.enter)="info()">
    </div>


    <div class="footer">
        <saffron-button text="INFO"
                        data-testid="btn-toast-info"
                        size="wide" 
                        type="primary" 
                        [is_loading]="loading"
                        (click)="info()">
        </saffron-button>
        <saffron-button text="ERROR"
                        data-testid="btn-toast-error"
                        size="wide" 
                        type="danger" 
                        [is_loading]="loading"
                        (click)="warning()">
        </saffron-button>
        <saffron-button text="SUCCESS"
                        data-testid="btn-toast-success"
                        size="wide" 
                        type="secondary" 
                        [is_loading]="loading"
                        (click)="success()">
        </saffron-button>
    </div>

    
</div>